import { LoadingStatusType, PeakPayrollExceptionCode, TypeComponentNoti } from "@/enums/enums";
import {
  SetHeaderDepartmentTable,
  SetTapsDepartmentTable,
  ToDepartmentModal,
  ValidateCreateDepartmentTemplate,
} from "@/helper/departmentHelper";
import { GetExceptionsByExceptionCode } from "@/helper/exceptionCodeHelper";
import { i18n } from "@/i18n";
import { DepartmentDetailModel } from "@/model/department/departmentDetailModel";
import { DepartmentModel } from "@/model/department/departmentModel";
import { DepartmentTableViewModel } from "@/model/department/departmentTableViewModel";
import {
  ConvertToDepartmentDetail,
  ConvertToDepartmentList,
  ConvertToDepartmentTable,
} from "@/service/department/departmentFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Department extends VuexModule {
  public departmentCreateId = 0;
  public createOrUpdateDepartmentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public departmentTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public departmentDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public departmentSuggestionCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public departmentSuggestionCode = "";
  public departmentDetail: any = null;
  public departmentTableList: any = [];
  public headerDepartmentTable: any = [];
  public tapsDepartmentTable: any = [];
  public departmentListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public departmentList: any = [];

  get getDepartmentCreateId(): number {
    return this.departmentCreateId;
  }
  get getCreateOrUpdateDepartmentLoadingStatus(): LoadingStatusType {
    return this.createOrUpdateDepartmentLoadingStatus;
  }
  get getDepartmentTableLoadingStatus(): LoadingStatusType {
    return this.departmentTableLoadingStatus;
  }
  get getDepartmentTableList(): any {
    return this.departmentTableList;
  }
  get getHeaderDepartmentTable(): any {
    return this.headerDepartmentTable;
  }
  get getTapsDepartmentTable(): any {
    return this.tapsDepartmentTable;
  }
  get getDepartmentDetail(): any {
    return this.departmentDetail;
  }
  get getdepartmentDetailLoadingStatus(): any {
    return this.departmentDetailLoadingStatus;
  }
  get getDepartmentList(): Array<DepartmentModel> {
    return this.departmentList;
  }
  get getDepartmentListLoadingStatus(): LoadingStatusType {
    return this.departmentListLoadingStatus;
  }
  get getDepartmentSuggestionCodeLoadingStatus(): LoadingStatusType {
    return this.departmentSuggestionCodeLoadingStatus;
  }
  get getDepartmentSuggestionCode(): string {
    return this.departmentSuggestionCode;
  }
  @Mutation
  public MutationDepartmentCreate(department: any) {
    this.departmentCreateId = department.id;
  }

  @Mutation
  public MutationCreateOrUpdateDepartmentLoadingStatus(status: LoadingStatusType) {
    this.createOrUpdateDepartmentLoadingStatus = status;
  }
  @Mutation
  public MutationGetDepartmentTable(input: any) {
    this.tapsDepartmentTable = SetTapsDepartmentTable(input.table.count);
    this.headerDepartmentTable = SetHeaderDepartmentTable(input.tableViewModel);
    this.departmentTableList = input.table.tableList;
  }
  @Mutation
  public MutationDepartmentTableLoadingStatus(status: LoadingStatusType) {
    this.departmentTableLoadingStatus = status;
  }

  @Mutation
  public MutationDepartmentDetailLoadingStatus(status: LoadingStatusType) {
    this.departmentDetailLoadingStatus = status;
  }

  @Mutation
  public MutationDepartmentDetail(departmentDetail: DepartmentDetailModel) {
    this.departmentDetail = departmentDetail;
  }

  @Mutation
  public MutationDepartmentListLoadingStatus(status: LoadingStatusType) {
    this.departmentListLoadingStatus = status;
  }

  @Mutation
  public MutationDepartmentList(departmentList: Array<DepartmentModel>) {
    this.departmentList = departmentList;
  }

  @Mutation
  public MutationSetPositionBydepartmentId(message: any) {
    this.departmentList.forEach((department: DepartmentModel) => {
      if (department.id === message.departmentId) {
        department.positionList = message.positionList;
      }
    });
  }
  @Mutation
  public MutationSetDepartmentSuggestionCodeLoadingStatus(loadingStatus: LoadingStatusType) {
    this.departmentSuggestionCodeLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationDepartmentSuggestionCode(code: string) {
    this.departmentSuggestionCode = code;
  }
  @Mutation
  public MutationResetDepartmentList() {
    this.departmentList = [];
    this.departmentListLoadingStatus = LoadingStatusType.None;
  }
  @Action
  public DoGetDepartmentTable(departmentTableViewModel: DepartmentTableViewModel) {
    if (this.departmentTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationDepartmentTableLoadingStatus", LoadingStatusType.Loading);
      API.DepartmentService.DoGetDepartmentTable(departmentTableViewModel).then((resGetDepartmentTable) => {
        if (resGetDepartmentTable.status.IsSuccess()) {
          const table = ConvertToDepartmentTable(resGetDepartmentTable.data.table);
          const input = {
            tableViewModel: departmentTableViewModel,
            table: table,
          };
          this.context.commit("MutationGetDepartmentTable", input);
        }

        this.context.commit("MutationDepartmentTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateDepartment(createDepartmentTemplate: any) {
    if (this.createOrUpdateDepartmentLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreateDepartmentTemplate = ValidateCreateDepartmentTemplate(createDepartmentTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreateDepartmentTemplate) {
        this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Loading);
        const departmentModal: DepartmentModel = ToDepartmentModal(createDepartmentTemplate);

        API.DepartmentService.DoCreateDepartment(departmentModal).then((resCreateDepartment) => {
          if (resCreateDepartment.data.responseCode.IsSuccess()) {
            this.context.commit("MutationDepartmentCreate", resCreateDepartment.data.department);
            inputAlert.alertMessage = i18n.t("Create_Message_Success", {
              message:
                i18n.t("Department") +
                " #" +
                departmentModal.code +
                " " +
                (i18n.locale == "en" ? departmentModal.nameEn : departmentModal.nameTh),
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationResetDepartmentList");
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Success);
          } else if (resCreateDepartment.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            createDepartmentTemplate.deptCode.validateError = true;
            inputAlert.alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", { text: i18n.t("Department") });
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
          } else if (resCreateDepartment.data.exception.code == PeakPayrollExceptionCode.CodeIsEmpty) {
            createDepartmentTemplate.deptCode.validateError = true;
            inputAlert.alertMessage = i18n.t("Exceptions_Notification.CodeIsEmpty", { text: i18n.t("Department") });
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
          } else {
            inputAlert.alertMessage = GetExceptionsByExceptionCode(resCreateDepartment.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdateDepartment(createDepartmentTemplate: any) {
    if (this.createOrUpdateDepartmentLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreateDepartmentTemplate = ValidateCreateDepartmentTemplate(createDepartmentTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreateDepartmentTemplate) {
        this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Loading);
        const departmentModal: DepartmentModel = ToDepartmentModal(createDepartmentTemplate);

        API.DepartmentService.DoUpdateDepartment(departmentModal).then((resUpdateDepartment) => {
          if (resUpdateDepartment.data.responseCode.IsSuccess()) {
            inputAlert.alertMessage = i18n.t("Update_Message_Success", {
              message:
                i18n.t("Department") +
                " #" +
                departmentModal.code +
                " " +
                (i18n.locale == "en" ? departmentModal.nameEn : departmentModal.nameTh),
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationResetDepartmentList");
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = GetExceptionsByExceptionCode(resUpdateDepartment.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdateDepartmentDeleted(departmentDetail: any) {
    if (this.createOrUpdateDepartmentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Loading);

      API.DepartmentService.DoUpdateDepartmentDeleted(departmentDetail.id).then((resUpdateDepartmentDeleted) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };

        if (resUpdateDepartmentDeleted.data.responseCode.IsSuccess()) {
          inputAlert.alertMessage = i18n.t("Remove_Message_Success", {
            message:
              i18n.t("Department") +
              " #" +
              departmentDetail.code +
              " " +
              (i18n.locale == "en" ? departmentDetail.nameEn : departmentDetail.nameTh),
          });
          inputAlert.typeMessage = TypeComponentNoti.Success;
          this.context.commit("MutationResetDepartmentList");
          this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Success);
        } else {
          inputAlert.alertMessage = GetExceptionsByExceptionCode(resUpdateDepartmentDeleted.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoUpdateDepartmentArchived(departmentDetail: any) {
    if (this.createOrUpdateDepartmentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Loading);
      API.DepartmentService.DoUpdateDepartmentArchived(departmentDetail).then((resUpdateDepartmentArchived) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        if (resUpdateDepartmentArchived.data.responseCode.IsSuccess()) {
          inputAlert.alertMessage = departmentDetail.isArchived
            ? i18n.t("Off_Message_Success", {
                message:
                  i18n.t("Department") +
                  " #" +
                  departmentDetail.code +
                  " " +
                  (i18n.locale == "en" ? departmentDetail.nameEn : departmentDetail.nameTh),
              })
            : i18n.t("On_Message_Success", {
                message:
                  i18n.t("Department") +
                  " #" +
                  departmentDetail.code +
                  " " +
                  (i18n.locale == "en" ? departmentDetail.nameEn : departmentDetail.nameTh),
              });
          inputAlert.typeMessage = TypeComponentNoti.Success;
          this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
        } else {
          inputAlert.alertMessage = GetExceptionsByExceptionCode(resUpdateDepartmentArchived.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.Fail);
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoGetDepartmentDetail(departmentId: number) {
    if (this.departmentDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationDepartmentDetailLoadingStatus", LoadingStatusType.Loading);

      API.DepartmentService.DoGetDepartmentDetail(departmentId).then((resGetDepartmentDetail) => {
        if (resGetDepartmentDetail.status.IsSuccess()) {
          const detail = ConvertToDepartmentDetail(resGetDepartmentDetail.data.detail);
          this.context.commit("MutationDepartmentDetail", detail);
        }

        this.context.commit("MutationDepartmentDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetDepartmentList() {
    if (this.departmentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationDepartmentListLoadingStatus", LoadingStatusType.Loading);

      API.DepartmentService.DoGetDepartmentList().then((resGetDepartmentList) => {
        if (resGetDepartmentList.status.IsSuccess()) {
          const departmentList = ConvertToDepartmentList(resGetDepartmentList.data.departmentList);
          this.context.commit("MutationDepartmentList", departmentList);
        }
        this.context.commit("MutationDepartmentListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetDepartmentSuggestionCode() {
    if (this.departmentSuggestionCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetDepartmentSuggestionCodeLoadingStatus", LoadingStatusType.Loading);
      API.DepartmentService.DoGetDepartmentSuggestionCode().then((resGetDepartmentSuggestionCode) => {
        if (resGetDepartmentSuggestionCode.status.IsSuccess()) {
          this.context.commit("MutationDepartmentSuggestionCode", resGetDepartmentSuggestionCode.data.code);
        }
        this.context.commit("MutationSetDepartmentSuggestionCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
